export default class ButtonModal {
    constructor() {
        this.openButtons = document.querySelectorAll('[data-module="modal-button"]');
        this.accordionButtons = document.querySelectorAll('.c-modal__accordion-trigger');
        this.init();
    }

    init() {
        this.setupModalButtons();
        this.setupAccordionButtons();
    }

    setupModalButtons() {
        if (!this.openButtons.length) return;

        this.openButtons.forEach(button => {
            const modal = document.querySelector(`#${button.dataset.target}`);
            if (!modal) return;

            const closeButton = modal.querySelector('.c-modal__close-button');
            const overlay = modal.querySelector('.c-modal__dialog');

            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.showModal(modal);
                document.dispatchEvent(new CustomEvent("ajaxModalHasLoaded"));
            });

            closeButton.addEventListener('click', () => this.hideModal(modal));

            modal.addEventListener('click', (e) => {
                if (e.target === modal || e.target === overlay) {
                    this.hideModal(modal);
                }
            });

            window.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && modal.open) {
                    this.hideModal(modal);
                }
            });
        });
    }

    setupAccordionButtons() {
        if (!this.accordionButtons.length) return;

        const accordion = document.querySelector('.c-modal__accordion');
        if (!accordion) return;

        const allowMultiple = accordion.getAttribute('data-accordion-mode') === 'multiple';

        this.accordionButtons.forEach(button => {
            button.addEventListener('click', () => {
                const expanded = button.getAttribute('aria-expanded') === 'true';
                this.toggleAccordion(button, !expanded, allowMultiple);
            });

            button.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const expanded = button.getAttribute('aria-expanded') === 'true';
                    this.toggleAccordion(button, !expanded, allowMultiple);
                }
            });
        });
    }

    toggleAccordion(button, expand, allowMultiple) {
        const panel = document.getElementById(button.getAttribute('aria-controls'));

        if (!allowMultiple) {
            this.accordionButtons.forEach(btn => {
                if (btn !== button) {
                    btn.setAttribute('aria-expanded', 'false');
                    const btnPanel = document.getElementById(btn.getAttribute('aria-controls'));
                    btnPanel.setAttribute('aria-hidden', 'true');
                }
            });
        }

        button.setAttribute('aria-expanded', expand);
        panel.setAttribute('aria-hidden', !expand);
    }

    showModal(modal) {
        if (modal.open) return;

        const content = modal.querySelector('.c-modal__content')

        modal.showModal();
        modal.focus({ preventScroll: true })

        document.body.classList.add('modal-open'); // Prevent background scroll
    }

    hideModal(modal) {
        if (!modal.open) return;

        modal.close();
        document.body.classList.remove('modal-open');
    }
}